// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MessageChatSquareDefault } from '../../../assets/icons/default/communication/message-chat-square.svg?react';
import { ReactComponent as MessageChatSquareSolid } from '../../../assets/icons/solid/communication/MESSAGE-CHAT-SQUARE.svg?react';
import { createIcons } from '../../Icon';
const MessageChatSquareIcon = /* @__PURE__ */ createIcons('MessageChatSquare', {
    default: MessageChatSquareDefault,
    solid: MessageChatSquareSolid
});
MessageChatSquareIcon.supportedTypes = ['default', 'solid'];
MessageChatSquareIcon.category = 'communication';
export default MessageChatSquareIcon;
